<template>
  <Field v-slot="{ errors }" :name="name">
    <vl-form-message-error v-show="errors" v-vl-spacer:top.medium>{{ errors[0] }}</vl-form-message-error>
  </Field>
</template>

<script lang="ts" setup>
import { Field } from 'vee-validate';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
});
</script>
